export const screenSizeManager = {
  initial: 'idle',
  invoke: { src: 'watchScreenMode' },
  states: {
    idle: {
      on: {
        ENVIRONMENT_SCREEN_SIZE_CHANGED: [
          {
            cond: 'isPromotionsPage',
            actions: [
              'saveCurrentScreenSize',
              'layout_changePageId',
              'layout_reload',
              'setBodyScrollable',
              'scrollTop',
            ],
          },
          {
            cond: 'isSearchPage',
            actions: ['saveCurrentScreenSize', 'scrollTop'],
          },
          {
            actions: [
              'saveCurrentScreenSize',
              'layout_reload',
              'setBodyScrollable',
              'scrollTop',
            ],
            target: 'initializePersonalizedBannersAfterDelay',
          },
        ],
      },
    },
    /**
     * Fetching promo banners data must be delayed due to a conflict during layout rendering
     * and manipulation of banner elements by the Basecamp script
     */
    initializePersonalizedBannersAfterDelay: {
      after: {
        800: {
          target: 'initializePersonalizedBanners',
        },
      },
    },
    initializePersonalizedBanners: {
      invoke: {
        src: 'initializePersonalizedBannersWithContext',
        onDone: 'idle',
      },
    },
  },
};
